import { createRouter, createWebHashHistory } from 'vue-router'
import IndexView from '../views/Index'
import NewsdetailView from '../views/newsdetail'
import NewslistView from '../views/newslist'
import ProjectdetailView from '../views/projectdetail'
import ProjectdingdanlView from '../views/projectdingdan'
import RegisterView from '../views/register'
import LoginView from '../views/login'
import HuiyuanView from '../views/huiyuan'

const routes = [
  {
    path: '/',
    name: 'index',
    meta:{title:"首页"},
    component: IndexView
  },
  {
    path: '/newsdetail',
    name: 'newsdetail',
    meta:{title:"信息详情"},
    component: NewsdetailView
  },
  {
    path: '/newslist',
    name: 'newslist',
    meta:{title:"信息列表"},
    component: NewslistView
  },
  {
    path: '/projectdetail',
    name: 'projectdetail',
    meta:{title:"项目详情"},
    component: ProjectdetailView
  },
  {
    path: '/projectdingdan',
    name: 'projectdingdan',
    meta:{title:"项目下单"},
    component: ProjectdingdanlView
  },
  {
    path: '/register',
    name: 'register',
    meta:{title:"会员注册"},
    component: RegisterView
  },
  {
    path: '/login',
    name: 'login',
    meta:{title:"会员登录"},
    component: LoginView
  },
  {
    path: '/huiyuan',
    name: 'huiyuan',
    meta:{title:"会员中心"},
    component: HuiyuanView
  }
  
  
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title; // 设置页面标题
  }
  next();
});
export default router
